import { Card, Col, Row, Spin, Typography } from "antd";
import React, { ReactElement, ReactNode } from "react";

import { AppFooter } from "~/Modules/LandingPage/Components/Footer/Footer";
import InvestImg from "@assets/KPMG/Invest.png";
import MainHeader from "../MainHeader/MainHeader";
import cs from "classnames";
import styles from "./WrapperCard.module.scss";
import { useLocation } from "react-router-dom";

type PropsType = {
  title?: any;
  text?: any;
  image?: any;
  action?: ReactElement;
  children: ReactNode;
  loading?: boolean;
  smallHeader?: boolean;
  customTitle?: boolean;
  bodyClass?: string;
};

export const WrapperLayout = ({ title, text, image, children }: PropsType) => {
  const location = useLocation();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <div>
        {location.pathname !== "/knowledgehub" && (
          <MainHeader title={title} imageSrc={image} text={text} />
        )}

        <Row justify="center">
          <Col lg={2}></Col>
          <Col lg={20} style={{ marginTop: "1.5rem" }}>
            {children}
          </Col>
          <Col lg={2}></Col>
        </Row>
      </div>
      <div>
        <AppFooter />
      </div>
    </div>
  );
};

